import React from "react";
import { GoDotFill } from "react-icons/go";
import { PiChatsFill } from "react-icons/pi";

import {
  emptyString,
  DEFAULT_VALUE,
  inboxPageConstants,
  CONVERSATION_STATUS_ICON_SIZE,
  UNREAD_DOT_ICON_SIZE,
} from "../../../constants";
import {
  onKeyDownHandler,
  UTCToDateFormat,
  UTCToDateTimeFormatWithMonthAndDay,
} from "../../../../../shared";
import LastMessageComponent from "./lastMessageComponent";
import ConversationStatusIcon from "./conversationStatusIcon";

const { UNREAD_MESSAGE_DOT_COLOR } = inboxPageConstants;

const conversationCardColor = (conv, selectedConversation) => {
  if (selectedConversation?.customerId === conv.customerId) {
    return "opened-chat";
  }
  if (conv.hasUnreadMessages || conv.isNew) {
    return "bg-white";
  }
  return "bg-secondary bg-opacity-10";
};

/**
 * Single conversation row in the inbox sidebar list.
 */
const ConversationCard = ({
  conv,
  selectedConversation,
  onConversationClick,
}) => {
  const isUnread = conv.hasUnreadMessages || conv?.isNew;

  return (
    <div
      role="button"
      tabIndex={0}
      key={conv.id}
      data-testId="conversation"
      className={`px-2 py-2 border-2 border-bottom pointer position-relative ${conversationCardColor(
        conv,
        selectedConversation,
      )}`}
      onClick={() => onConversationClick(conv)}
      onKeyDown={(e) => {
        onKeyDownHandler(e, () => {
          onConversationClick(conv);
        });
      }}
    >
      <div className="d-flex align-items-start gap-2">
        <div className="w-100">
          <div className="d-flex flex-wrap justify-content-between align-items-top">
            <div className="d-flex justify-content-start align-items-center">
              {isUnread && (
                <GoDotFill
                  data-testid="unread-message-dot"
                  color={UNREAD_MESSAGE_DOT_COLOR}
                  size={UNREAD_DOT_ICON_SIZE}
                  className="me-1"
                />
              )}
              <h6
                className={`${
                  isUnread
                    ? "unread-customer-name"
                    : "read-customer-name opacity-75"
                } mb-0 text-truncate text-truncate-20ch`}
                title={conv.customerName}
              >
                {conv.customerName}
              </h6>
            </div>
            {conv.lastCommunication !== DEFAULT_VALUE && (
              <small
                className="opacity-75 mb-0 bold-6"
                title="Last Conversation Date"
              >
                {UTCToDateTimeFormatWithMonthAndDay(conv.lastCommunication)}
              </small>
            )}
          </div>
          <LastMessageComponent conversation={conv} />
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <div>
                <small
                  className={`text-truncate text-truncate-30ch ${
                    isUnread
                      ? "unread-customer-name"
                      : "read-customer-name opacity-75"
                  }`}
                  title={conv?.conversationStoreName}
                >
                  {conv?.conversationStoreName}
                </small>
              </div>
              <div>
                <small
                  className={`mb-0 bold-6 ${
                    isUnread ? emptyString : "opacity-75"
                  }`}
                  title="Survey Completion Date"
                >
                  Survey Completion: {UTCToDateFormat(conv.surveyCompletionDate)}
                </small>
              </div>
            </div>
            <div className="d-flex align-items-center gap-2">
              <div>
                {conv.message !== null && (
                  <span className="p-1 rounded bg-secondary bg-opacity-25 d-flex align-items-center text-dark">
                    <PiChatsFill size={CONVERSATION_STATUS_ICON_SIZE} />
                  </span>
                )}
              </div>
              <div>
                <ConversationStatusIcon status={conv.conversationStatus} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversationCard;
